export type { InputProps } from "@components/contracts/Input.types";
export {
  CelebrationNumberInput,
  CelebrationTextInput,
} from "./Input.adapter";
